export interface Ability {
  id: number;
  name: string;
  title: string;
  label?: string;
  entityId: null;
  entityType: AbilityEntityType;
  onlyOwned: number;
  options: OptionsAbility;
  scope: null;
  createdAt: Date;
  updatedAt: Date;
  pivot: Pivot;
  module: string;
  checked: boolean;
  isActive: boolean;
}

export enum AbilityEntityType {
  AppModelsClientGuaranteeLetter = "App\\Models\\ClientGuaranteeLetter",
  AppModelsApproval = "App\\Models\\Approval",
  AppModelsCef = "App\\Models\\Cef",
  AppModelsCompany = "App\\Models\\Company",
  AppModelsCompanyGroup = "App\\Models\\CompanyGroup",
  AppModelsPolicy = "App\\Models\\Policy",
  AppModelsRequest = "App\\Models\\Request",
  AppModelsUser = "App\\Models\\User",
}

export interface Pivot {
  entityType: PivotEntityType;
  entityId: number;
  abilityId: number;
}

export interface OptionsAbility {
  description: string;
  internal: boolean;
  module: string;
}

export enum PivotEntityType {
  Roles = "roles",
}
